import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
import { donorapi } from '../../ApiNames';


export const fetchDataSuccess = (data: any) => ({
    type: 'FETCH_DATA_SUCCESS',
    payload: data,
});
export const fetchDataSuccessmsg = (msgdata: any) => ({
    type: 'FETCH_DATA_SUCCESS_MAG',
    payload: msgdata,
});

//To get list of officers data
export const fetchData = (uid:any,usertype:any,donationID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { Userid:uid,usertype:usertype,need:donationID };

            const apiname = donorapi.donorchat;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

export const addmsgdata = (uid:any,message:any,donationID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { Userid:uid,message:message,need:donationID,q:1 };
            const apiname = donorapi.msg;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataSuccessmsg(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};